module.exports = __webpack_public_path__ + "img/mejorGol.63451f6c.gif";